import { LoadableAfterPaint } from '@confluence/loadable';

export const LinkToThisPageDialog = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LinkToThisPageDialog" */ './LinkToThisPageDialog.js'
			)
		).LinkToThisPageDialog,
});
